import React from 'react';
import { MainLayout } from '@/components/layouts/MainLayout';
import { ExportImportPanel } from '@/components/export/ExportImportPanel';
import { SubscriptionGuard } from '@/components/auth/SubscriptionGuard';
import { FileSpreadsheet } from 'lucide-react';

export const ExportImport: React.FC = () => {
  return (
    <MainLayout 
      title="Export / Import" 
      actions={
        <div className="flex items-center gap-2">
          <FileSpreadsheet className="w-5 h-5 text-muted-foreground" />
        </div>
      }
    >
    <div className="space-y-6">
      <div className="flex items-center justify-between">
        <div>
          <h1 className="text-3xl font-bold tracking-tight">Gestion des données</h1>
          <p className="text-muted-foreground">
            Exportez et importez vos données produits et ventes
          </p>
        </div>
      </div>

      <ExportImportPanel />
    </div>
    </MainLayout>
  );
};